var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.167,
    cy: 24.5,
    r: 22.3047,
    stroke: "white",
    strokeWidth: 4.3906
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2738 8.27278C28.286 8.27278 31.2396 9.10577 33.8079 10.6797C36.3763 12.2535 38.4593 14.507 39.8269 17.1909C41.1944 19.8749 41.7931 22.8847 41.5567 25.8876C41.3204 28.8906 40.2583 31.7697 38.4877 34.2066C36.7172 36.6436 34.3072 38.5434 31.5243 39.6962C28.7413 40.8489 25.6938 41.2096 22.7187 40.7384C19.7435 40.2671 16.9566 38.9824 14.6661 37.0261C12.3756 35.0698 10.6707 32.5182 9.73984 29.6534L25.2738 24.6061L25.2738 8.27278Z",
    fill: "#F2CA88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeG);
export default __webpack_public_path__ + "static/media/typeG.82dd19238c056a413d9806cb536d017a.svg";
export { ForwardRef as ReactComponent };